import React, { useContext } from "react";
import { useMsal } from "@azure/msal-react";
import { FormDataContext } from "context/FormDataContext";
import styled from "styled-components";

function handleLogout(instance) {
  instance
    .logoutRedirect({
      postLogoutRedirectUri: "/",
    })
    .catch((e) => {
      console.error(e);
    });
}

export const SignOutButton = () => {
  const { instance, accounts } = useMsal();
  const name = accounts[0] && accounts[0].name;
  const { currentOrganization } = useContext(FormDataContext);

  return (
    <UserInfo>
      <Username>{name}</Username>
      <Organization>{currentOrganization[1]}</Organization>
      <Button
        variant="secondary"
        className="ml-auto"
        onClick={() => handleLogout(instance)}
      >
        Afslut
      </Button>
    </UserInfo>
  );
};

const Username = styled.div`
  color: #ffffff;
  font-weight: bold;
`;

const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const Organization = styled.div`
  color: #ffffff;
`;

const Button = styled.button`
  background-color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 0.35em 1.25em 0.25em 1.25em;
  margin: 2em 0 1em 0;
`;
